import "../../style/carousalContainer.css";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { config, BASEURL } from "../../config/config";
import axios from "axios";
import { AppContext, useAppContext } from "../../context/context";
import intercepter from "../../server/intercepter";
import { SafeImage } from "./SafImage";
import { getS3Url } from "../../utlity/utlityFunctions";
import PostMedia from "../PostMedia";

// function CarouselPage({ item, userData: user, authStory, deleteStory }) {
//   const userData = {
//     id: user._id ? user._id : user.id ? user.id : "",
//     ...user,
//   };

//   const [show, setShow] = useState(false);
//   const { state } = useAppContext(AppContext);

//   // const userStories = async () => {
//   //   try {
//   //     const res = await intercepter.get(
//   //       `${BASEURL}/stories/story/${userData.id}`,
//   //       config
//   //     );
//   //   } catch (error) {
//   //     console.log(error);
//   //   }
//   // };

//   return (
//     <>
//       {userData?.id ? (
//         <>
//           <div className="column" onClick={() => setShow(true)}>
//             <div className="ms-3">
//               <div className="postImgTop">
//                 <SafeImage
//                   className="userImg"
//                   src={
//                     userData?.Photo
//                       ? userData?.Photo.includes("/public/")
//                         ? `${BASEURL}${userData?.Photo}`
//                         : getS3Url(userData?.Photo)
//                       : "/images/user.png"
//                   }
//                   alt="followerImage"
//                 />
//               </div>
//               <p>{userData.userName}</p>
//             </div>
//           </div>
//         </>
//       ) : (
//         ""
//       )}

//       <Modal
//         show={show}
//         onHide={() => setShow(false)}
//         dialogClassName="modal-100w"
//         aria-labelledby="example-custom-modal-styling-title"
//       >
//         <Modal.Header closeButton>
//           <div className="postImgTop">
//             <SafeImage
//               className="userImg"
//               src={
//                 userData?.Photo
//                   ? userData?.Photo.includes("/public/")
//                     ? `${BASEURL}${userData?.Photo}`
//                     : getS3Url(userData?.Photo)
//                   : "/images/user.png"
//               }
//               alt="followerImage"
//             />
//           </div>
//           <pre className="ms-2">{userData?.userName}</pre>
//           {/* <div>
//             <button
//               onClick={() => {
//                 deleteStory();
//               }}
//             >
//               delete
//             </button>
//           </div> */}
//         </Modal.Header>
//         <Carousel fade>
//           {item[0]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   item[0]?.photo
//                     ? item[0]?.photo.includes("/public/")
//                       ? `${BASEURL}${item[0]?.photo}`
//                       : getS3Url(item[0]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{item[0]?.body}</h3>

//                 <StoryViewersList userId={state.user?.id} story={item[0]} />
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {item[1]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   item[1]?.photo
//                     ? item[1]?.photo.includes("/public/")
//                       ? `${BASEURL}${item[1]?.photo}`
//                       : getS3Url(item[1]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{item[1]?.body}</h3>
//                 <StoryViewersList userId={state.user?.id} story={item[1]} />
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {item[2]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   item[2]?.photo
//                     ? item[2]?.photo.includes("/public/")
//                       ? `${BASEURL}${item[2]?.photo}`
//                       : getS3Url(item[2]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{item[2]?.body}</h3>
//                 <StoryViewersList userId={state.user?.id} story={item[2]} />
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {item[3]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   item[3]?.photo
//                     ? item[3]?.photo.includes("/public/")
//                       ? `${BASEURL}${item[3]?.photo}`
//                       : getS3Url(item[3]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{item[3]?.body}</h3>
//                 <StoryViewersList userId={state.user?.id} story={item[3]} />
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {item[4]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   item[4]?.photo
//                     ? item[4]?.photo.includes("/public/")
//                       ? `${BASEURL}${item[4]?.photo}`
//                       : getS3Url(item[4]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{item[4]?.body}</h3>
//                 <StoryViewersList userId={state.user?.id} story={item[4]} />
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {item[5]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   item[5]?.photo
//                     ? item[5]?.photo.includes("/public/")
//                       ? `${BASEURL}${item[5]?.photo}`
//                       : getS3Url(item[5]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{item[5]?.body}</h3>
//                 <StoryViewersList userId={state.user?.id} story={item[5]} />
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//         </Carousel>
//       </Modal>
//     </>
//   );
// }

// export default CarouselPage;

function CarouselPage({ item = [], userData: user, deleteStory }) {
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);
  const [muted, setMuted] = useState(false);
  const [activeFullScreenPost, setActiveFullScreenPost] = useState(null);

  const { state } = useAppContext(AppContext);

  const userData = {
    id: user?._id || user?.id || "",
    ...user,
  };

  const getImageUrl = (path) => {
    if (!path) return "/images/user.png";

    return path.includes("/public/") ? `${BASEURL}${path}` : getS3Url(path);
  };

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);

    // auto close after last story
    if (selectedIndex === item.length - 1) {
      setTimeout(() => {
        setShow(false);
        setIndex(0);
      }, 15000);
    }
  };

  const openModal = () => {
    setShow(true);
    setIndex(0);
  };

  const closeModal = () => {
    setShow(false);
    setIndex(0);
  };

  return (
    <>
      {userData?.id && (
        <div className="column" onClick={openModal}>
          <div className="ms-3 text-center">
            <div className="postImgTop story-border">
              <SafeImage
                className="userImg"
                src={getImageUrl(userData?.Photo)}
                alt="user"
              />
            </div>
            <p className="story-username">{userData?.userName}</p>
          </div>
        </div>
      )}

      <Modal
        show={show}
        onHide={closeModal}
        centered
        dialogClassName="story-modal"
      >
        <Modal.Header closeButton className="story-header">
          <div className="d-flex align-items-center">
            <div className="postImgTop">
              <SafeImage
                className="userImg"
                src={getImageUrl(userData?.Photo)}
                alt="user"
              />
            </div>

            <span className="ms-2 fw-bold">{userData?.userName}</span>
          </div>

          {/* Optional delete button */}
          {/* <button
            className="btn btn-danger btn-sm"
            onClick={deleteStory}
          >
            Delete
          </button> */}
        </Modal.Header>

        <Modal.Body
          className="p-0"
          style={{
            height: "80vh",
            maxHeight: "100vh",
            overflow:
              "hidden" /* Completely disables vertical and horizontal scrolling */,
          }}
        >
          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            fade
            interval={15000}
            indicators={false}
            controls={item.length > 1}
          >
            {item?.map((story, i) =>
              story?.photo ? (
                <Carousel.Item key={story?._id || i}>
                  {/* <SafeImage
                    src={getImageUrl(story.photo)}
                    className="d-block w-100 story-image"
                    alt={`story-${i}`}
                  /> */}

                  <PostMedia
                    item={story}
                    muted={muted}
                    setMuted={setMuted}
                    activeFullScreenPost={activeFullScreenPost}
                    setActiveFullScreenPost={setActiveFullScreenPost}
                  />

                  <Carousel.Caption className="story-caption">
                    {story?.body && <h5>{story.body}</h5>}

                    <StoryViewersList userId={state?.user?.id} story={story} />
                  </Carousel.Caption>
                </Carousel.Item>
              ) : null,
            )}
          </Carousel>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CarouselPage;

//storyViewers list model
function StoryViewersList({ story, userId }) {
  const [show, setShow] = useState(false);
  const [storyViewers, setStoryViewers] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //get viewerslist
  const getViewerslist = async () => {
    try {
      const res = await intercepter.get(
        `${BASEURL}/stories/storyViewerslist/${story._id}`,
        config,
      );
      const resData = await res.data.data;
      setStoryViewers(resData);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <button
        className={story.postedBy === userId ? "btn button m-2 p-2" : "d-none"}
        onClick={() => {
          handleShow();
          getViewerslist();
        }}
      >
        {story.views.length} views
      </button>
      {/* <div>
       <GrFormView className={story.postedBy === userId ? "fs-2 text-light" : "d-none"}
        onClick={() => {
          handleShow();
          getViewerslist();
        }} />
    </div>  */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Story Viewers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {storyViewers.length > 0 ? (
            <>
              {storyViewers.map((item) => {
                return (
                  <>
                    <div>
                      <div className="d-flex flex-wrap gap-3 mb-2">
                        <div className="postImgTop">
                          <SafeImage
                            alt=""
                            className="userImg"
                            src={
                              item.Photo
                                ? item.Photo.includes("/public/")
                                  ? `${BASEURL}${item.photo}`
                                  : getS3Url(item.Photo)
                                : "/images/user.png"
                            }
                          />
                        </div>
                        <p>{item.userName}</p>
                      </div>
                    </div>
                  </>
                );
              })}
            </>
          ) : (
            ""
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export { StoryViewersList };

// //following page following stories
// function CarouselPage2({ userData: user }) {
//   const { state } = useAppContext(AppContext);

//   const userData = {
//     id: user._id ? user._id : user.id ? user.id : "",
//     ...user,
//   };

//   const [show, setShow] = useState(false);
//   const [stories, setStories] = useState([]);

//   const userStories = async () => {
//     try {
//       const res = await intercepter.get(
//         `${BASEURL}/stories/story?userId=${state.user.id}&storyUserId=${userData.id}`,
//         config,
//       );
//       setStories(res.data.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <>
//       {userData?.id ? (
//         <>
//           <div className="column" onClick={() => setShow(true)}>
//             <div className="ms-3">
//               <div className="postImgTop" onClick={userStories}>
//                 <SafeImage
//                   className="userImg"
//                   src={
//                     userData?.Photo
//                       ? userData?.Photo.includes("/public/")
//                         ? `${BASEURL}${userData?.Photo}`
//                         : getS3Url(userData?.Photo)
//                       : "/images/user.png"
//                   }
//                   alt="followerImage"
//                 />
//               </div>
//               <p>{userData.userName}</p>
//             </div>
//           </div>
//         </>
//       ) : (
//         ""
//       )}

//       <Modal
//         show={show}
//         onHide={() => setShow(false)}
//         dialogClassName="modal-100w"
//         aria-labelledby="example-custom-modal-styling-title"
//       >
//         <Modal.Header closeButton>
//           <div className="postImgTop">
//             <SafeImage
//               className="userImg"
//               src={
//                 userData?.Photo
//                   ? userData?.Photo.includes("/public/")
//                     ? `${BASEURL}${userData?.Photo}`
//                     : getS3Url(userData?.Photo)
//                   : "/images/user.png"
//               }
//               alt="followerImage"
//             />
//           </div>
//           <pre className="ms-2">{userData?.userName}</pre>
//           {/* <div>
//             <button
//               onClick={() => {
//                 deleteStory();
//               }}
//             >
//               delete
//             </button>
//           </div> */}
//         </Modal.Header>
//         <Carousel fade>
//           {stories[0]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   stories[0]?.photo
//                     ? stories[0]?.photo.includes("/public/")
//                       ? `${BASEURL}${stories[0]?.photo}`
//                       : getS3Url(stories[0]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{stories[0]?.body}</h3>
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {stories[1]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   stories[1]?.photo
//                     ? stories[1]?.photo.includes("/public/")
//                       ? `${BASEURL}${stories[1]?.photo}`
//                       : getS3Url(stories[1]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{stories[1]?.body}</h3>
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {stories[2]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   stories[2]?.photo
//                     ? stories[2]?.photo.includes("/public/")
//                       ? `${BASEURL}${stories[2]?.photo}`
//                       : getS3Url(stories[2]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{stories[2]?.body}</h3>
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {stories[3]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   stories[3]?.photo
//                     ? stories[3]?.photo.includes("/public/")
//                       ? `${BASEURL}${stories[3]?.photo}`
//                       : getS3Url(stories[3]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{stories[3]?.body}</h3>
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {stories[4]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   stories[4]?.photo
//                     ? stories[4]?.photo.includes("/public/")
//                       ? `${BASEURL}${stories[4]?.photo}`
//                       : getS3Url(stories[4]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{stories[4]?.body}</h3>
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//           {stories[5]?.photo && (
//             <Carousel.Item interval={1000}>
//               <SafeImage
//                 src={
//                   stories[5]?.photo
//                     ? stories[5]?.photo.includes("/public/")
//                       ? `${BASEURL}${stories[5]?.photo}`
//                       : getS3Url(stories[5]?.photo)
//                     : "/images/user.png"
//                 }
//                 className="d-block w-100"
//                 alt="..."
//               />
//               <Carousel.Caption>
//                 <h3>{stories[5]?.body}</h3>
//               </Carousel.Caption>
//             </Carousel.Item>
//           )}
//         </Carousel>
//       </Modal>
//     </>
//   );
// }

// export { CarouselPage2 };

function StoriesList({ allStory }) {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openStory = (index) => {
    setSelectedIndex(index);
  };

  const nextStoryUser = () => {
    if (selectedIndex === null) return;

    if (selectedIndex < allStory.length - 1) {
      setSelectedIndex(selectedIndex + 1);
    } else {
      setSelectedIndex(null); // close after last user
    }
  };

  return (
    <>
      <div className="stories-container">
        {allStory?.map((item, index) => (
          <div key={index} onClick={() => openStory(index)}>
            <CarouselPage2 userData={item._id} />
          </div>
        ))}
      </div>

      {selectedIndex !== null && (
        <CarouselPage2
          userData={allStory[selectedIndex]._id}
          showModal={true}
          onClose={() => setSelectedIndex(null)}
          onStoryEnd={nextStoryUser}
        />
      )}
    </>
  );
}

export { StoriesList };

function CarouselPage2({ userData: user }) {
  const { state } = useAppContext(AppContext);

  const [show, setShow] = useState(false);
  const [stories, setStories] = useState([]);
  const [index, setIndex] = useState(0);
  const [muted, setMuted] = useState(true);
  const [activeFullScreenPost, setActiveFullScreenPost] = useState(null);

  const userData = {
    id: user?._id || user?.id || "",
    ...user,
  };

  const getImageUrl = (path) => {
    if (!path) return "/images/user.png";

    return path.includes("/public/") ? `${BASEURL}${path}` : getS3Url(path);
  };

  const userStories = async () => {
    try {
      const res = await intercepter.get(
        `${BASEURL}/stories/story?userId=${state.user.id}&storyUserId=${userData.id}`,
        config,
      );

      setStories(res.data.data || []);
      setShow(true);
      setIndex(0);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);

    if (selectedIndex === stories.length - 1) {
      setTimeout(() => {
        setShow(false);
        setIndex(0);
      }, 15000);
    }
  };

  return (
    <>
      {userData?.id && (
        <div className="story-user" onClick={userStories}>
          <div className="story-border">
            <SafeImage
              className="story-avatar"
              src={getImageUrl(userData?.Photo)}
              alt="user"
            />
          </div>

          <p className="story-name">{userData?.userName}</p>
        </div>
      )}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        dialogClassName="story-modal"
      >
        <Modal.Header closeButton className="story-header">
          <div className="d-flex align-items-center">
            <SafeImage
              className="story-avatar"
              src={getImageUrl(userData?.Photo)}
              alt="user"
            />
            <span className="ms-2">{userData?.userName}</span>
          </div>
        </Modal.Header>

        <Modal.Body
          className="p-0"
          style={{
            height: "60vh",
            maxHeight: "100vh",
            overflow:
              "hidden" /* Completely disables vertical and horizontal scrolling */,
          }}
        >
          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            fade
            interval={15000}
            indicators={false}
            controls={stories.length > 1}
          >
            {stories?.map((story, i) => (
              <Carousel.Item key={story?._id || i}>
                {/* <SafeImage
                  src={getImageUrl(story?.photo)}
                  className="story-image"
                  alt={`story-${i}`}
                /> */}

                <PostMedia
                  item={story}
                  muted={muted}
                  setMuted={setMuted}
                  activeFullScreenPost={activeFullScreenPost}
                  setActiveFullScreenPost={setActiveFullScreenPost}
                />

                <Carousel.Caption>
                  <h5>{story?.body}</h5>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </Modal.Body>
      </Modal>
    </>
  );
}

export { CarouselPage2 };
